module.exports = __webpack_public_path__ + "media/images/recipes/biefstuk-c8876e13c0912052251fc53ae3b891e8.pdf";